import React, { Fragment, useEffect, useCallback } from 'react';
import {
  useRouteMatch,
  Route,
  useHistory,
  useLocation
} from 'react-router-dom';
import { Text } from 'components/v3/ui';
import Avatar from 'components/v3/Avatar';
import Table from 'components/v3/List/Table';
import { useListFetcher } from 'components/v3/utils';
import UserModal from './Modal';

const columns = [
  {
    Header: ' ',
    accessor: 'settings.color',
    kind: 'color'
  },
  {
    Header: ' ',
    accessor: 'avatar',
    width: '56px',
    Cell: ({ item }) => <Avatar user={item} />
  },
  {
    Header: 'Prénom',
    accessor: 'firstName',
    width: '22.5%',
    Cell: ({ item }) => <Text variant="small">{item.firstName}</Text>
  },
  {
    Header: 'Nom',
    accessor: 'lastName',
    width: '22.5%',
    Cell: ({ item }) => <Text variant="small">{item.lastName}</Text>
  },
  {
    Header: 'Email',
    accessor: 'email',
    width: '35%',
    Cell: ({ item }) => <Text variant="small">{item.email}</Text>
  },
  {
    Header: 'Role',
    accessor: 'displayTopRole',
    width: 'calc(20% - 56px - 24px)',
    Cell: ({ item }) => (
      <Text variant="caption" color="theme">
        {item.displayTopRole}
      </Text>
    )
  }
];

const UserList = ({
  selector,
  action,
  options = {
    fetchOnMount: false,
    useLocalState: true
  },
  params = {
    sort: 'first_name,last_name'
  },
  perPage = 25,
  filters,
  onCountChanged,
  detailUrlPrefix = '/membres',
  ...props
}) => {
  const { path, url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const [users, paginationHelper, state] = useListFetcher({
    selector,
    action,
    options,
    params,
    perPage,
    filters
  });

  const detailLinkFormatter = useCallback(
    item => `${path}${detailUrlPrefix}/${item.id}`,
    [path, detailUrlPrefix]
  );

  useEffect(() => {
    if (paginationHelper.total != null && onCountChanged) {
      onCountChanged(paginationHelper.total);
    }
  }, [paginationHelper.total, onCountChanged]);

  return (
    <Fragment>
      <Table
        columns={columns}
        items={users}
        isLoading={state.isLoading}
        linkFormatter={detailLinkFormatter}
        centerMessage={state.errorMessage}
        estimatedItemSize={54 + (props.spacing || 0) / 2}
        {...paginationHelper}
        {...props}
      />
      <Route
        path={[
          `${path}${detailUrlPrefix}/nouveau-membre`,
          `${path}${detailUrlPrefix}/:userId`
        ]}
      >
        <UserModal
          onRequestClose={() => {
            if (location.key) {
              history.goBack();
            } else {
              history.replace(url);
            }
          }}
        />
      </Route>
    </Fragment>
  );
};

export default UserList;
